var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardmoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.99 7.22998H9.99C6.82 7.22998 4.24 9.80998 4.24 12.98V17.98C4.24 20.05 5.92 21.73 7.99 21.73H15.99C18.06 21.73 19.74 20.05 19.74 17.98V12.98C19.74 9.80998 17.16 7.22998 13.99 7.22998ZM8.24 12.48C8.24 11.79 8.8 11.23 9.49 11.23C10.18 11.23 10.74 11.79 10.74 12.48C10.74 13.17 10.18 13.73 9.49 13.73C8.8 13.73 8.24 13.17 8.24 12.48ZM9.99 17.73C9.8 17.73 9.61 17.66 9.46 17.51C9.17 17.22 9.17 16.74 9.46 16.45L13.46 12.45C13.75 12.16 14.23 12.16 14.52 12.45C14.81 12.74 14.81 13.22 14.52 13.51L10.52 17.51C10.37 17.66 10.18 17.73 9.99 17.73ZM14.49 18.73C13.8 18.73 13.24 18.17 13.24 17.48C13.24 16.79 13.8 16.23 14.49 16.23C15.18 16.23 15.74 16.79 15.74 17.48C15.74 18.17 15.18 18.73 14.49 18.73Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36 5.9301C8.89 5.8101 9.43 5.7401 9.99 5.7401H13.99C14.55 5.7401 15.1 5.8101 15.62 5.9301L16.69 3.2701C16.83 2.9201 16.69 2.5201 16.36 2.3401C16.03 2.1601 15.62 2.2401 15.39 2.5401C14.88 3.2201 14.08 3.2401 13.99 3.2401C13.14 3.2401 12.64 2.6101 12.59 2.5401C12.31 2.1601 11.67 2.1601 11.39 2.5401C10.88 3.2201 10.08 3.2401 9.99 3.2401C9.14 3.2401 8.64 2.6101 8.59 2.5401C8.36 2.2401 7.95 2.1501 7.62 2.3401C7.29 2.5201 7.15 2.9201 7.29 3.2701L8.36 5.9301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardmoney);
export default __webpack_public_path__ + "static/media/hardmoney.69dcfdde5506ff647bd0deb4600c5145.svg";
export { ForwardRef as ReactComponent };